import React, { ReactElement } from 'react';
import cx from 'classnames';

import styles from './ArticlesTagsSearch.module.scss';
import Input from '../../../../sharable/components/Input';
import { SearchIcon } from 'app/scripts/icons';

interface IArticlesTagsSearchProps {
  className?: string;
  onChange: (e: any) => void;
}

const ArticlesTagsSearch = ({ className, onChange }: IArticlesTagsSearchProps): ReactElement => {
  return (
    <div className={cx(styles.container, className)}>
      <label htmlFor="articles-tag-search">
        <SearchIcon className={styles.searchIcon} />
      </label>

      <Input
        id="articles-tag-search"
        className={styles.searchInput}
        placeholder="Search article tags"
        isBorderless
        onChange={onChange}
      />
    </div>
  );
};

export default ArticlesTagsSearch;
